
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { ref } from 'vue'
import { Icon, useHeaderScroll } from '@mg/micro/vue2'
import { HeaderShell } from '@mg/micro/vue2/HeaderShell'
import { FeaturesConfig } from '@mg/web-components/types'
import HeaderMobileIcons from './HeaderMobileIcons.vue'
import HeaderDesktopIcons from './HeaderDesktopIcons.vue'

import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'

// TODO replace image with banner from banMan
@Component({
  setup() {
    const headerElRef = ref<HTMLElement | null>(null)

    const { isHidden } = useHeaderScroll({
      headerEl: headerElRef,
      aboveHeaderElId: 'above-header',
    })

    return {
      headerElRef,
      isHiddenMobile: isHidden,
    }
  },
  apollo: {
    account: {
      query: GQL_LOCAL_ACCOUNT,
    },
  },
  components: {
    HeaderShell,
    HeaderDesktopIcons,
    HeaderMobileIcons,
    Icon,
  },
})
export default class HeaderBasic extends Vue {
  logoHeight = 42
  isHeaderVisible = true

  @Prop({ required: false, type: Object })
  readonly featuresConfig?: FeaturesConfig

  @Ref('headerEl') readonly headerEl!: any

  // provided by the `setup()` component option above (Vue 2.7 Composition API)
  headerElRef!: HTMLElement | null
  isHiddenMobile!: boolean

  mounted() {
    this.headerElRef = this.headerEl?.$el as HTMLElement
  }

  get logoName() {
    return `LogoMall${this.$shopConfig.shopId}`
  }
}
